export default __webpack_public_path__ + "static/media/LeftTwoButton.29fb6e48.webp";